export enum RecipientActions {
    Edit = 1,
    PairedDonors = 2,
    Toolbox = 3,
    PotentialDonors = 4,
    Order3gTissueTyping = 5,
    UtilizeBulkCheekSwab = 6,
    EnrollRecipientShield = 7,
}